import { cn } from '@creator/ui/utils/ui';
import type { FC, PropsWithChildren } from 'react';

export interface AProps extends PropsWithChildren {
    target?: string;
    href?: string;
    className?: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

const A: FC<AProps> = props => {
    const { onClick, children, target, href, className } = props;

    const _props = {
        target: target,
        className: cn('break-words', className),
        href: href,
        rel: 'noopener noreferrer',
        onClick,
    };

    return <a {..._props}>{children}</a>;
};

export default A;
